export default __webpack_public_path__ + "static/media/1.8869dcc4.png";